<script lang="ts">
  import OpenNewIcon from '$icons/OpenNewIcon.svelte';
  import SignalIcon from '$icons/SignalIcon.svelte';
  import Button from '../Button.svelte';
  import CheckboxIcon from '$icons/CheckboxIcon.svelte';
  import {
    HackathonParticipationStatus,
    HackathonPhase,
    type HackathonWithState,
  } from '$shared/lib';
  import HackathonBanner from './HackathonBanner.svelte';
  import { formatHackathonDate } from '$utils/date';
  import BuildIcon from '$icons/BuildIcon.svelte';
  import EditPencilIcon from '$icons/edit/EditPencilIcon.svelte';
  import UploadIcon from '$icons/Upload.svelte';
  import ShowEyeIcon from '$icons/ShowEyeIcon.svelte';
  import StarIcon from '$icons/StarIcon.svelte';
  import { getHackathonLink } from '$lib/constants/hackathon';
  import RocketIcon from '$icons/RocketIcon.svelte';
  import ArrowRight from '$icons/arrows/ArrowRight.svelte';
  import QuestionIcon from '$icons/QuestionIcon.svelte';
  import CodeIcon from '$icons/CodeIcon.svelte';
  import PlusCircleIcon from '$icons/PlusCircleIcon.svelte';
  import Upload from '$icons/Upload.svelte';
  import MagnifyingGlass from '$icons/MagnifyingGlass.svelte';
  import TrophyIcon from '$icons/TrophyIcon.svelte';
  import LongPaperIcon from '$icons/LongPaperIcon.svelte';

  export let hackathon: HackathonWithState;
  $: name = hackathon.name;
  $: landerRoute = hackathon.landingPageUrl;
</script>

<div class="border-gray-dark-2 bg-gray-dark-0 mb-6 flex flex-col gap-3 rounded border p-3">
  {#if hackathon}
    <HackathonBanner {hackathon} showCountDown />
  {/if}

  <div>
    <div class="p mb-2.5 flex w-full items-start space-x-2">
      <h2 class="font-architekt text-gray-dark-12 flex items-center text-sm leading-6 sm:text-base">
        {#if hackathon.phase === HackathonPhase.REGISTRATION}
          {#if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <CheckboxIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />You're Registered for {name}!
            </span>
          {:else}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <LongPaperIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Join the {name} Hackathon
              - Registration Now Open!
            </span>
          {/if}
        {:else if hackathon.phase === HackathonPhase.PROJECT_CREATION}
          {#if hackathon.participationStatus >= HackathonParticipationStatus.PROJECT_CREATED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <CheckboxIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Your Project is Ready
              for {name}!
            </span>
          {:else if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <BuildIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Start Creating Your
              Project for {name}!
            </span>
          {:else if hackathon.participationStatus === HackathonParticipationStatus.NOT_REGISTERED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <LongPaperIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Register for {name} to
              start creating your project!
            </span>
          {/if}
        {:else if hackathon.phase === HackathonPhase.PROJECT_SUBMISSION}
          {#if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_SUBMITTED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <CheckboxIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Your Project Has Been
              Submitted!
            </span>
          {:else if hackathon.participationStatus === HackathonParticipationStatus.NOT_REGISTERED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <EditPencilIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Project Submission
              is open for {name}! Register to participate.
            </span>
          {:else if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <BuildIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Project Submission is
              open for {name}!
            </span>
          {:else if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_CREATED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <UploadIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Ready to Submit Your
              Project for {name}?
            </span>
          {:else}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <EditPencilIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Project Submission
              is now open for {name}!
            </span>
          {/if}
        {:else if hackathon.phase === HackathonPhase.HACKATHON_ENDED}
          <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
            <ShowEyeIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Hackathon Ended -
            Projects Under Review
          </span>
        {:else if hackathon.phase === HackathonPhase.WINNERS_ANNOUNCED}
          {#if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_SUBMITTED}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <StarIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Winners Announced - Thank
              you for participating!
            </span>
          {:else}
            <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
              <StarIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />Winners Announced for {name}
            </span>
          {/if}
        {:else}
          <span class="flex items-start gap-x-1.5 leading-tight sm:gap-x-2">
            <EditPencilIcon class="text-gray-dark-12 h-5 w-5 flex-shrink-0" />{name}
          </span>
        {/if}
      </h2>
      {#if hackathon.phase > HackathonPhase.REGISTRATION && hackathon.phase < HackathonPhase.HACKATHON_ENDED}
        <div class="hidden items-center gap-x-1.5 sm:flex">
          <SignalIcon class="text-red-dark-11 h-4 w-4 animate-pulse" />
          <span class="text-gray-dark-11 text-sm">Live</span>
        </div>
      {/if}
    </div>
    <div class="text-gray-dark-11 flex items-start gap-x-4 text-xs leading-4 sm:text-sm">
      <div class="flex items-start gap-x-1.5">
        {#if hackathon.phase === HackathonPhase.REGISTRATION}
          <span>
            {#if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
              Get ready to showcase your skills, build on Solana, and compete for amazing prizes.
              Check out our resources below to start planning your project!
            {:else}
              The hackathon kicks off on {formatHackathonDate(new Date(hackathon.startDate))}. Don't
              miss out on this opportunity to showcase your skills and win amazing prizes!
            {/if}
          </span>
        {:else if hackathon.phase === HackathonPhase.PROJECT_CREATION}
          <span>
            The project submission portal will be open from {formatHackathonDate(
              new Date(hackathon.projectSubmissionStartDate),
            )} to {formatHackathonDate(new Date(hackathon.projectSubmissionEndDate))}.
            {#if hackathon.participationStatus === HackathonParticipationStatus.NOT_REGISTERED}
              Register now to start creating your project!
            {:else if hackathon.participationStatus >= HackathonParticipationStatus.PROJECT_CREATED}
              You can continue to edit your project and team info until the submission phase.
            {:else}
              Before then, you can save your project and team info, and share it with others on the
              platform!
            {/if}
          </span>
        {:else if hackathon.phase === HackathonPhase.PROJECT_SUBMISSION}
          <span>
            {#if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_SUBMITTED}
              Your project has been successfully submitted! You can continue to edit your submission
              until the portal closes on {formatHackathonDate(
                new Date(hackathon.projectSubmissionEndDate),
              )}. Make sure to finalize any changes before the deadline.
            {:else}
              The project submission portal is open from {formatHackathonDate(
                new Date(hackathon.projectSubmissionStartDate),
              )} to {formatHackathonDate(new Date(hackathon.projectSubmissionEndDate))}.
              {#if hackathon.participationStatus === HackathonParticipationStatus.NOT_REGISTERED}
                Register now to participate!
              {:else if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
                Create your project to participate!
              {:else if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_CREATED}
                Your project is ready - submit it now to join the competition!
              {:else}
                Project Submission is now open for {name}!
              {/if}
            {/if}
          </span>
        {:else if hackathon.phase === HackathonPhase.HACKATHON_ENDED}
          <span>
            {#if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_SUBMITTED}
              The {name} hackathon has ended. Your project is currently under review. Stay tuned for
              results!
            {:else if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_CREATED}
              The {name} hackathon has ended. Your project was not submitted for review.
            {:else if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
              The {name} hackathon has ended. You registered but did not submit a project.
            {:else}
              The {name} hackathon has ended. Projects are currently under review.
            {/if}
          </span>
        {:else if hackathon.phase === HackathonPhase.WINNERS_ANNOUNCED}
          <span>
            {#if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_SUBMITTED}
              Winners for the {name} hackathon have been announced. Thank you for your participation!
            {:else if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_CREATED}
              Winners for the {name} hackathon have been announced. While your project wasn't submitted,
              we appreciate your effort.
            {:else if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
              Winners for the {name} hackathon have been announced. Although you didn't submit a project,
              we hope you'll participate in future events!
            {:else}
              Winners for the {name} hackathon have been announced. Explore the winning projects and
              stay tuned for future events!
            {/if}
          </span>
        {:else if hackathon.projectSubmissionEndDate}
          <span>
            Project submission ends on {formatHackathonDate(
              new Date(hackathon.projectSubmissionEndDate),
            )}.
          </span>
        {/if}
      </div>
    </div>
  </div>
  <div class="flex items-center justify-between">
    {#if hackathon.phase === HackathonPhase.REGISTRATION}
      {#if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
        <div class="flex w-full flex-wrap items-start gap-x-2 gap-y-3">
          <Button href={getHackathonLink('faq')} target="_blank" secondary size="sm">
            FAQ
            <QuestionIcon slot="right-icon" class="ml-1 h-4 w-4" />
          </Button>
          <Button href={getHackathonLink('developerResources')} target="_blank" secondary size="sm">
            Developer Resources
            <CodeIcon slot="right-icon" class="ml-1 h-4 w-4" />
          </Button>
          <Button href={getHackathonLink('exploreProjects')} target="_blank" secondary size="sm">
            Explore Past Projects
            <MagnifyingGlass slot="right-icon" class="ml-1 h-4 w-4" />
          </Button>
        </div>
      {:else}
        <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
          Register
          <RocketIcon slot="right-icon" class="ml-1 h-4 w-4" />
        </Button>
      {/if}
    {:else if hackathon.phase === HackathonPhase.PROJECT_CREATION}
      {#if hackathon.participationStatus === HackathonParticipationStatus.NOT_REGISTERED}
        <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
          Register
          <RocketIcon slot="right-icon" class="ml-1 h-4 w-4" />
        </Button>
      {:else if hackathon.participationStatus >= HackathonParticipationStatus.PROJECT_CREATED}
        <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
          View Your Project
          <ArrowRight slot="right-icon" class="ml-1 h-4 w-4" />
        </Button>
      {:else}
        <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
          Create Project
          <PlusCircleIcon slot="right-icon" class="ml-1 h-4 w-4" />
        </Button>
      {/if}
    {:else if hackathon.phase === HackathonPhase.PROJECT_SUBMISSION}
      {#if hackathon.participationStatus === HackathonParticipationStatus.PROJECT_SUBMITTED}
        <div class="flex flex-wrap items-center gap-2">
          <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
            Edit Project Submission
            <EditPencilIcon slot="right-icon" class="ml-1 h-4 w-4" />
          </Button>
        </div>
      {:else if hackathon.participationStatus === HackathonParticipationStatus.NOT_REGISTERED}
        <Button secondary size="sm" href={getHackathonLink('register')}>
          Register
          <RocketIcon slot="right-icon" class="ml-1 h-4 w-4" />
        </Button>
      {:else if hackathon.participationStatus === HackathonParticipationStatus.REGISTERED}
        <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
          Create Project
          <PlusCircleIcon slot="right-icon" class="ml-1 h-4 w-4" />
        </Button>
      {:else if hackathon.participationStatus >= HackathonParticipationStatus.PROJECT_CREATED}
        <div class="flex flex-wrap items-center gap-2">
          <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
            Submit Project
            <Upload slot="right-icon" class="ml-1 h-4 w-4" />
          </Button>
        </div>
      {/if}
    {:else if hackathon.phase === HackathonPhase.HACKATHON_ENDED}
      <div class="flex flex-col gap-4">
        <div class="flex flex-wrap items-center gap-2">
          {#if hackathon.participationStatus >= HackathonParticipationStatus.PROJECT_CREATED}
            <Button secondary size="sm" href={getHackathonLink('hackathonDashboard')}>
              View Your Project
              <ArrowRight slot="right-icon" class="ml-1 h-4 w-4" />
            </Button>
          {:else}
            <Button secondary size="sm" href={getHackathonLink('exploreProjects')}>
              Explore Projects
              <MagnifyingGlass slot="right-icon" class="ml-1 h-4 w-4" />
            </Button>
          {/if}
        </div>
      </div>
    {:else if hackathon.phase === HackathonPhase.WINNERS_ANNOUNCED}
      <div class="flex flex-col gap-4">
        <div class="flex flex-wrap items-center gap-2">
          <Button secondary size="sm" href={getHackathonLink('hallOfFame')}>
            View Winners
            <TrophyIcon slot="right-icon" class="ml-1 h-4 w-4" />
          </Button>
        </div>
      </div>
    {/if}
    <div class="hidden items-center gap-x-2 sm:flex">
      <Button quinary size="sm" target="_blank" icon href={landerRoute}>
        <OpenNewIcon />
      </Button>
    </div>
  </div>
  <div class="-my-2 flex items-center gap-x-2 sm:hidden">
    <Button quinary size="sm" target="_blank" icon href={landerRoute}>
      <OpenNewIcon />
    </Button>
  </div>
</div>
